/**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap(map, markers = []) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if (markers.length == 1) {
            map.panTo(bounds.getCenter());
            if(map.getZoom()<= 12) {
                map.setZoom(12);
            }

            // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }

/********************* for show partners map ************************************/
    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map) {
        if(window.theme_path === undefined || window.theme_path === null){
            window.theme_path = '/wp-content/themes/l-acoustics';
        }
        // Get position from marker.
        var lat = $marker.lat;
        var lng = $marker.lng;
        
        // Validate coordinates
        if (lat !== '' && lng !== '' && lat !== null && lng !== null && 
            lat !== undefined && lng !== undefined && 
            !isNaN(parseFloat(lat)) && !isNaN(parseFloat(lng))) {
            var latLng = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };

            // Create marker instance.
            if($marker.post_type === 'providers') {
                switch ($marker.provider_type) {
                    case 'Rentals':
                        var image = {
                            url: window.theme_path + "/src/img/map/marker_rentals.svg", // url
                            scaledSize: new google.maps.Size(48, 48)
                        };
                        break;
                    case 'Integration':
                        var image = {
                            url: window.theme_path + "/src/img/map/marker_integration.svg", // url
                            scaledSize: new google.maps.Size(48, 48)
                        };
                        break;
                    case 'Distribution':
                        var image = {
                            url: window.theme_path + "/src/img/map/marker_distribution.svg", // url
                            scaledSize: new google.maps.Size(48, 48)
                        };
                        break;
                    default:
                        var image = {
                            url: window.theme_path + "/src/img/map/marker.svg", // url
                            scaledSize: new google.maps.Size(48, 48)
                        };
                }
            }
            else if($marker.post_type === 'l-isa-studios') {
                var image = {
                    url: window.theme_path + "/src/img/map/l-isa-studio-pin.svg", // url
                    scaledSize: new google.maps.Size(48, 48)
                };
            }
            else if($marker.post_type === 'lisa_auditoriums') {
                var image = {
                    url: window.theme_path + "/src/img/map/l-isa-auditoria-pin.svg", // url
                    scaledSize: new google.maps.Size(48, 48)
                };
            }
            else if($marker.post_type === 'lisa_venues') {
                
                var image = {
                    url: window.theme_path + "/src/img/map/l-isa-venue-pin.svg", // url
                    scaledSize: new google.maps.Size(48, 48)
                };
                
            }
            else if($marker.post_type === 'certified_venues' ) {
                
                var image = {
                    url: window.theme_path + "/src/img/map/l-isa-certified-pin.svg", // url
                    scaledSize: new google.maps.Size(48, 48)
                };
                
            }
            else if($marker.post_type === 'training_centers') {
                
                var image = {
                    url: window.theme_path + "/src/img/map/marker_training.svg", // url
                    scaledSize: new google.maps.Size(48, 48)
                };
                
            }
            else{
                var image = {
                    url: window.theme_path + "/src/img/map/marker.svg", // url
                    scaledSize: new google.maps.Size(48, 48)
                };
            }

            var marker = new google.maps.Marker({
                position: latLng,
                map: map,
                icon: image,
                visible: false
            });
            marker.infos = $marker;

            marker.getDistanceWith  = function (otherMarker, unit='km') {
                return getDistanceWith(this, otherMarker,unit);
            };

            // Append to reference for later use.
            map.markers.push(marker);
            //console.log('Created marker for:', $marker.name, 'post_type:', $marker.post_type, 'coordinates:', latLng);

            // Create info window.
            marker.infowindow = new google.maps.InfoWindow({
                content: getHtmlProviderInfo(marker)
            });

            // Append infoWindow reference for later use.
            map.infoWindows.push(marker.infowindow);

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function () {
                hideAllInfoWindow(map);
                marker.infowindow.open(map, marker);
            });
        } else {
            // Skip markers with invalid coordinates
            console.warn('Skipping marker with invalid coordinates:', $marker.name, 'lat:', lat, 'lng:', lng);
            return;
        }
    }

    function geocodeAddress(address, geocoder, resultsMap) {
        geocoder.geocode({ address: address }, (results, status) => {
            if (status === "OK") {
                resultsMap.poi.setPosition(results[0].geometry.location);
                resultsMap.setCenter(results[0].geometry.location);
                if (results[0].types.find(type => type === 'country')) {
                    resultsMap.setZoom(6);
                } else if (results[0].types.find(type => type === 'continent')) {
                    resultsMap.setZoom(4);
                } else if (results[0].types.find(type => type === 'locality')) {
                    resultsMap.setZoom(11);
                } else if (results[0].types.find(type => type === 'street_address') ||
                    results[0].types.find(type => type === 'point_of_interest')) {
                    resultsMap.setZoom(15);
                } else{
                    resultsMap.setZoom(6);
                }
                //resultsMap.setBounds(results[0].geometry.bounds);
            } else {
                console.debug("Geocode was not successful for the following reason: " + status);
            }
        });
    }

    function geocodeFromField(fieldElement, map){
        if(fieldElement.value.length > 2){
            hideMarkers(map.markers);
            let latLng = geocodeAddress(fieldElement.value, map.geocoder, map);
            map.poi.setPosition(latLng);
        }
    }
    function searchFieldGeocode(map){
        var searchField = document.getElementById('search-provider');
    /*    searchField.addEventListener('blur', function(e){
            console.log(e);
            geocodeFromField(this, map);
        });*/
       searchField.addEventListener('keypress', function(e){
            if(e.key === "Enter") {
                geocodeFromField(this, map);
            }
        });
    }

    function getVisibleMarkers(map){
        var bounds = map.getBounds(),
            count = 0,
            visibles = [];
        var markers  =  map.markers;

        for (var i = 0; i < markers.length; i++) {
            var marker = markers[i];
            if(bounds.contains(marker.getPosition())===true) {
                visibles.push(marker);
                count++;
            }
        }

        jQuery('#infos').html(count);
        return visibles;
    }

    function buildTagLine(data){
        let line = [];
        if (data.provider_type === "Rentals") {
            let keys = Object.keys(data.system);
            if (keys.length > 0) {
                for (key of keys.reverse()) {
                    if (key === 'Kara') {
                        key = 'Kara (II)';
                    }
                    if (key === 'Kiva') {
                        key = 'Kiva II';
                    }
                    if (key === 'A') {
                        key = 'A-Series';
                    }
                    line.push(key);
                }
            }

            if (data.lisa_certified == 1) {
                line.push("L-ISA");
            }
        }
        if (data.provider_type === "Integration") {
            if (data.la_creations == 1) {
                line.push("L-Acoustics Creations");
            }
            // if (data.system_integrator_network_agent == 1) {
            //     line.push("System Integrator Network Agent");
            // }
        }
        return line.join(', ');
    }

    function appendPointToDom(map, marker, wrapper, classes, poi = null, unit = 'km'){
        if(window.theme_path === undefined ||window.theme_path === null){
            window.theme_path = '/wp-content/themes/l-acoustics';
        }
        let data = marker.infos;
        let tags = buildTagLine(data);
        let distance = (poi !== null) ? marker.getDistanceWith(poi, unit) + ' ' + unit : '';
        let separator = tags !== '' ? ' - ' : '';
        let point = document.createElement("div");
        let title = "";
        title += '<a href="#">' + data.name + '</a>';
        if(data.certified_provider !== undefined && data.certified_provider != null &&
            data.certified_provider !== 0 && data.certified_provider !== ""){
            title += '<img src="'+ theme_path + '/src/img/map/icon_certified_provider.svg">';
        }
        point.className = "provider " + classes;
        let content = '<div class="provider-content">';
        content += '<div class="row no-gutters"><div class="title col-lg-12">';
        content += title;
        if ( data.post_type == 'certified_venues') {
            content += '<img class="certified-badge" src="'+ theme_path + '/src/img/map/l-isa-certified-badge.svg">';
        }
        //console.log(data);
        content += '</div></div>';
        content += '<div class="row no-gutters"><div class="city col-lg-9">' + data.city + separator + '<span class="tags">' + tags +  '</span></div>';
        if(data.website !== undefined && data.website != null && data.website !== '') {
            content += '<div class="website col-lg-3"><a target="_blank" href="' + data.website + '">Website</a></div></div>';
        }
        content += '</div>';
        point.innerHTML = content;
        point.addEventListener('click', function () {
            centerMap(map, [marker]);
            hideAllInfoWindow(map);
            marker.infowindow.open(map, marker);
        });
        wrapper.appendChild(point);
    }

    function updatePointsList(map, points, list_wrapper){
        list_wrapper.innerHTML = '';
        var count = 1;
        for (point of points){
            appendPointToDom(map, point, list_wrapper, 'point-' + count, map.poi);
            count++;
        }
        uddateListResults();
    }

    function getHtmlProviderInfo(marker) {
        var data = marker.infos;
        let inventory_standards_content = "";

        if (data.provider_type !== undefined &&
            data.provider_type === "Rentals") {
            var standard_system_table = [
                ['K1', '', 'K1'],
                ['K2', '', 'K2'],
                ['K3', '', 'K3'],
                ['Kara', '', 'Kara (II)'],
                ['Kiva', '', 'Kiva II'],
                ['A', '', 'A-Series'],
                ['L2', '', 'L2']
            ];
            var cnt = 0;
            for (standard of standard_system_table) {
                if (data.system[standard[0]] !== undefined && data.system[standard[0]] !== null) {
                    standard_system_table[cnt][1] = data.system[standard[0]].join(', ');
                }
                cnt++;
            }
            //console.log(marker.infos.system);
            if ( "L-ISA" in marker.infos.system ) {

                inventory_standards_content += '<div class="d-flex align-items-center mt-3">';
                inventory_standards_content += '<div class="l-isa-logo-holder"></div>';
                inventory_standards_content += '<span class="ml-2 pb-1"><small>Agent</small></span>';
                inventory_standards_content += '</div>';
            }
            let available_systems = [];
            for (const item of standard_system_table) {
                if (item[1] !== "") {
                    available_systems.push(item[2] + ' (' + item[1] + ')');
                }
            }
            if (available_systems.length > 0) {
                inventory_standards_content += '<div class="d-flex flex-column mt-3">';
                inventory_standards_content += '<span class="pl-1 pb-1"><strong>Available systems:</strong></span>';
                inventory_standards_content += '<span class="pl-1 pb-1 tags">' + available_systems.join(', ') + '</span>';
                inventory_standards_content += '</div>';
            }
            // table_content += '<table data-toggle="modal" data-target="#system-standard-table-modal">';
            // table_content += '<tr><th colspan="2">Inventory Standard</th></tr>';
            inventory_standards_content += '<div class="wp-block-button is-style-outline d-flex justify-content-center" data-toggle="modal" data-target="#system-standard-table-modal">';
            inventory_standards_content += '<a href="#" class="wp-block-button__link has-black-color">';
            inventory_standards_content += 'View inventory standard';
            // inventory_standards_content += '<tr><th colspan="2">Inventory Standard</th></tr>';
            // for (standard of standard_system_table) {
            //     inventory_standards_content += '<tr><td>' + standard[2] + '</td><td>' + standard[1] + '</td></tr>';
            // }
            inventory_standards_content += '</a>';
            inventory_standards_content += '</div>';
            // table_content += '</table>';
            // table_content += '<p><small>Click on the table to display the inventory standard definition</small></p>';
        }
        let content = '<div class="infos-provider">';
        if ( data.post_type == 'certified_venues') {
            content += '<div class="cv-badge-container pr-2">';
            content += '<img class="certified-badge" src="'+ theme_path + '/src/img/map/l-isa-certified-badge.svg">';
            content += '</div>';
        }
        content += '<div class="info-container">';
        if(data.label !== undefined && data.label != null && data.label !== '') {
            content += '<div class="title">' + data.label + '</div>';
        }else{
            content += '<div class="title">' + data.name + '</div>';
        }
        //content += '<div class="systems">' + table_content + '</div>';
       if ( document.body.classList.contains('page-template-find_an_l_isa_venue') ) {
           if(data.city !== undefined && data.city != null && data.city !== '') {
               content += '<div class="city">'+ data.city + '</div>';
           }
       }
       else {
           if(data.adresse1 !== undefined && data.adresse1 != null && data.adresse1 !== '') {
               content += '<div class="adress">'+ data.adresse1 + '</div>';
           }
           if(data.adresse2 !== undefined && data.adresse2 != null && data.adresse2 !== '') {
               content += '<div class="adress">'+ data.adresse2 + '</div>';
           }
           if(data.country !== undefined && data.country != null && data.country !== '') {
               content += '<div class="adress">'+ data.country + '</div>';
           }
           if(data.phone_number !== undefined && data.phone_number != null && data.phone_number !== '') {
               content += '<div class="phonenumber">Phone: ' + data.phone_number + '</div>';
           }
           if(data.contact_email !== undefined && data.contact_email != null && data.contact_email !== '') {
               content += '<div class="contact-email"><a href="mailto:' + data.contact_email + '">Mail</a></div>';
           }
       }
        if(data.website !== undefined && data.website != null && data.website !== '') {
            content += '<div class="website"><a target="_blank" href="' + data.website + '">Website</a></div>';
        }
        if(data.profile_link !== undefined && data.profile_link != null && data.profile_link !== '') {
            content += '<div class="profile_link mt-2"><a target="_blank" href="' + data.profile_link + '">Profile</a></div>';
        }

        content += '</div></div>';

        content += '<div class="systems">' + inventory_standards_content + '</div>';
        content += '</div>';
        return content;
    }

    function hideMarkers(markers){
        markers.forEach(function(marker){
            marker.setOptions({visible: false});
        });
    }

    function showMarkers(markers){
        markers.forEach(function(marker){
            marker.setOptions({visible: true});
        });
    }

    function hideAllInfoWindow(map){
        map.infoWindows.forEach(function(infoWindow){
            infoWindow.close();
        });
    }

    function getDistanceWith(marker1, marker2, unit = 'km'){
        // With geometry library
        //let distance;
        // let distanceMeters = google.maps.geometry.spherical.computeDistanceBetween(marker2.getPosition(),  marker1.getPosition());

        // Form scratch (0,01 diff)
        var R = 3958.8; // Radius of the Earth in miles
        var rlat1 = marker1.position.lat() * (Math.PI/180); // Convert degrees to radians
        var rlat2 = marker2.position.lat() * (Math.PI/180); // Convert degrees to radians
        var difflat = rlat2-rlat1; // Radian difference (latitudes)
        var difflon = (marker2.position.lng()- marker1.position.lng()) * (Math.PI/180); // Radian difference (longitudes)

        var distance = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));

        if(unit === 'km'){
            // distance = distanceMeters / 1000;
            distance = distance * 1.60934 ;
        }else if (unit=== 'miles'){

        }
        // return distance.toPrecision(3);
        return distance;
    }

    function filterMarkerBy(markers, element, key, checkbox = false, value = null){
        if(value === null) {
            value = getFilterValue(element, checkbox);
        }
        filtered_marker = markers.filter(function(marker){
            if (checkbox === true) {
                //if (key === "la_creations" || key === "system_integrator_network_agent") {
                if (key === "la_creations") {
                    if(value == 1){
                        return marker.infos[key] == 1;
                    }else{
                        return marker.infos[key] != 1;
                    }
                } else if (value == 1) {
                    return marker.infos[key] == 1;
                }else{
                    return true;
                }
            } else{
                if(value === 'all'){
                    return true;
                }
                else if(key === "system"){
                    return Object.keys(marker.infos[key]).indexOf(value) !== -1;
                }
                else {
                    return marker.infos[key].indexOf(value) !== -1;
                }
            }
        });
        return filtered_marker;
    }

    function filterMarkersByMarketSegments(markers) {
        var selectedMarketSegments = [];

        // Check if any checkbox is checked
        var anyCheckboxChecked = jQuery('#marketSegmentsFilter .checkbox-group input[type="checkbox"]:checked').length > 0;

        if (!anyCheckboxChecked) {
            // If none are checked, return all markers
            return markers;
        }

        jQuery('#marketSegmentsFilter .checkbox-group input[type="checkbox"]:checked').each(function() {
            selectedMarketSegments.push(jQuery(this).val());
        });
        // Filter markers based on selected market segment values
        var filteredMarkers = markers.filter(function(marker) {
            // Check if any selected market segment is present in the marker's market segments array
            return selectedMarketSegments.some(function(segment) {
                return marker.infos['market_segments'].indexOf(segment) !== -1;
            });
        });

        return filteredMarkers;
    }

    function filterSystemByStandard(markers){
        var system_selected = getFilterValue('#system');
        var standard_selected = getFilterValue('#standard');
        filtered_marker = markers.filter(function(marker){
            if(system_selected !== "all"){
                if(standard_selected  === "all"){
                    return Object.keys(marker.infos['system']).indexOf(system_selected) !== -1
                }else{
                    if(Object.keys(marker.infos['system']).indexOf(system_selected) !== -1){
                        let key = system_selected;
                        var stds = marker.infos.system[key];
                        if(stds !== undefined){
                            return stds.indexOf(standard_selected) !== -1;
                        }else{
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                }
            }else if(standard_selected  !== "all"){
                return marker.infos['standard'].indexOf(standard_selected) !== -1;
            }
            else{
                return true;
            }
        });
        return filtered_marker;
    }

    function orderMarkerBy(markers, key, boolean = true, desc = true){
        ordered_marker = markers.sort(function(marker1, marker2){
            // for boolean value 1 always > to 0 :-)
            if(boolean === true){
                if (marker1.infos[key] < marker2.infos[key]){
                    return 1;
                }
                else if(marker1.infos[key] > marker2.infos[key]){
                    return -1;
                }else{
                    return 0;
                }
            } else {
                var weight = 0;
                if(desc === true) {
                    if (marker1.infos[key] < marker2.infos[key]) {
                        weight = 1;
                    } else if (marker1.infos[key] > marker2.infos[key]) {
                        weight = -1;
                    } else {
                        $weight = 0;
                    }
                } else {
                    weight * -1;
                }
                return weight;
            }
        });
        return ordered_marker;
    }

    function orderByDistance(markers, map){
        ordered_marker = markers.sort(function(marker1, marker2){
            let distance1 = marker1.getDistanceWith(map.poi);
            let distance2 = marker2.getDistanceWith(map.poi);
            if (distance1 > distance2){
                return 1;
            }
            else if(distance1 < distance2){
                return -1;
            }else{
                return 0;
            }
        });
        return ordered_marker;
    }

    function orderVenuesByCertifiedFirst(markers) {
        return markers.sort(function (a, b) {
            const aCertified = a.infos.post_type === 'certified_venues';
            const bCertified = b.infos.post_type === 'certified_venues';

            if (aCertified && !bCertified) return -1;
            if (!aCertified && bCertified) return 1;
            return 0;
        });
    }

    function getFilterValue(field, checkbox = false){
        if(checkbox === true){
            return jQuery(field).prop('checked') ? 1: '';
        } else {
            return jQuery(field).val();
        }
    }

    function isHtmlElement(o){
        return (
            typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
                o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
        );
    }

    function resetDisplayInputSection(){
        jQuery(".panel-body").css('overflow-y', 'unset');
        jQuery(".panel-body .items-counter-wrapper").hide();
        jQuery(".panel-body .search .checkboxes").hide();
        jQuery(".input-section.distribution,.input-section.rentals, .input-section.integration").hide();
    }

    function syncPanelOverflow(forceAuto = false) {
        const $panel = jQuery('.panel-body');
        const $venueType = jQuery('.venue-type');

        if (!$panel.length) {
            return;
        }

        var hasListItems = jQuery('.component-list-body').children().length > 0;

        if (hasListItems || forceAuto) {
            $panel.css('overflow-y', 'auto');
            return;
        }

        $panel.css('overflow-y', 'unset');
    }

    function uddateListResults(lang = 'en'){
        let word = lang === 'en' ? 'result(s)' : 'resultat(s)';
        let results = jQuery('.panel-body .component-list-body .provider').length;
        let sentence = results > 0 ? results + ' ' + word : '';
        jQuery('.panel-body .items-counter-wrapper .items-counter').html(sentence);
        if (results > 0) {
            syncPanelOverflow(true);
        }
    }

    function syncVenuePanelHeight() {
        var $panel = jQuery('.panel-body');
        var $venueType = jQuery('.venue-type');

        if (!$panel.length || !$venueType.length) {
            return;
        }

        if ($venueType.hasClass('open')) {
            $panel.css({
                'max-height': '75vh',
                'height': 'auto'
            });
            syncPanelOverflow();
            return;
        }

        $panel.css({
            'height': '',
            'max-height': '75vh'
        });
        syncPanelOverflow();
    }

    function initMapForm(map, type = 'provider') {
        searchFieldGeocode(map);
        resetDisplayInputSection();
        
        // Configuration de base pour tous les types
        jQuery(".panel-body").css('overflow-y', 'unset');
        jQuery(".panel-body .items-counter-wrapper").show();

        if (type === 'venue') {
            var venueType = document.querySelector('.venue-type');
            if (venueType) {
                new MutationObserver(function () {
                    syncVenuePanelHeight();
                }).observe(venueType, {
                    attributes: true,
                    attributeFilter: ['class']
                });
                syncVenuePanelHeight();
            }

            jQuery(document).on('click', '.venue-type__trigger, .venue-type .custom-option', function () {
                setTimeout(function () {
                    syncVenuePanelHeight();
                }, 0);
            });

            jQuery(document).on('click', '.venue-type .custom-option', function () {
                jQuery('.venue-type .custom-option').removeClass('selected');
                jQuery('.venue-description').fadeOut();
                jQuery(this).addClass('selected');
                jQuery('.venue-description[data-description="' + jQuery(this).data('value') + '"]').fadeIn();
                var selectedType = jQuery(this).data('value');
                var showVenueFilters = selectedType === 'L-ISA Venue' || selectedType === 'L-ISA Certified Venue';
                jQuery('.concert-venue-filter, .theatre-venue-filter').toggle(showVenueFilters);
                jQuery('#concert-venues-only').prop('checked', false);
                jQuery('#theatre-venues-only').prop('checked', false);
                jQuery('.venue-type__trigger span').html(jQuery(this).html());
                refreshMapVenue(map, '.component-list-body');
            });

            jQuery('#premium-venue-select').on('change', function () {
                refreshMapVenue(map, '.component-list-body');
            });
        }
        
        // Gestion des changements dans les checkbox et selects
        jQuery(".panel-body .search .input-section input[type='checkbox'], .panel-body .search .input-section select").on('change', function () {
            if (jQuery('.venue-type').hasClass('open') && !jQuery(this).is('#concert-venues-only, #theatre-venues-only')) {
                syncPanelOverflow();
                return;
            }

            syncPanelOverflow(true);
            
            switch(type) {
                case 'provider':
                    refreshMap(map, '.component-list-body');
                    break;
                case 'training':
                    refreshMapTraining(map, '.component-list-body');
                    break;
                case 'auditorium':
                    refreshMapAuditorium(map, '.component-list-body');
                    break;
                case 'venue':
                    refreshMapVenue(map, '.component-list-body');
                    break;
            }
        });

        // Gestion spécifique au type provider
        if (type === 'provider') {
            for (const option of document.querySelectorAll(".custom-option")) {
                option.addEventListener('click', function() {
                    var providerType = this.getAttribute("data-value");
                    map.provider_type = providerType;
                    refreshMap(map, '.component-list-body');
                    resetDisplayInputSection();
                    
                    // Reset des champs
                    jQuery(".panel-body .search .input-section #search-provider").val('').css('background-image', '');
                    jQuery(".panel-body .search .input-section #system").val('all');
                    jQuery(".panel-body .search .input-section #standard").val('all');
                    jQuery(".panel-body .search .input-section #lisa-certified").prop("checked", false);
                    jQuery(".panel-body .search .input-section #la_creations").prop("checked", false);
                    jQuery(".panel-body .search .input-section #standard-kx").prop("checked", false);
                    jQuery(".panel-body .search .input-section #standard-k").prop("checked", false);
                    jQuery(".panel-body .search .input-section #standard-h").prop("checked", false);
                    jQuery(".panel-body .search .input-section #authorized-calibration-center").prop("checked", false);
                    jQuery(".panel-body .search .input-section #authorized-training-center").prop("checked", false);

                    // Gestion de l'affichage
                    if(providerType !== 'all'){
                        syncPanelOverflow(true);
                        jQuery(".panel-body .items-counter-wrapper").show();
                        jQuery(".panel-body .search .checkboxes").show();
                    } else {
                        syncPanelOverflow();
                        jQuery(".panel-body .items-counter-wrapper").hide();
                        jQuery(".panel-body .search .checkboxes").hide();
                    }

                    // Gestion spécifique pour Rentals
                    if (providerType == 'Rentals') {
                        jQuery(".map-section .table-responsive").removeClass('hide').addClass('show');
                    } else {
                        jQuery(".map-section .table-responsive").removeClass('show').addClass('hide');
                    }

                    jQuery(".panel-body .search .input-section." + providerType.toLowerCase()).show();
                });
            }
        }

        // Gestion du champ de recherche texte
        jQuery(".panel-body .search .input-section input[type='text']").on('change', function () {
            jQuery(this).css('background-image', jQuery(this).val() !== '' ? 'none' : '');
            syncPanelOverflow(true);
        });
    }

function refreshMapGeneric(map, list_wrapper, mapType = 'provider') {
        if(typeof list_wrapper === 'string'){
            list_wrapper = document.querySelector(list_wrapper);
        } else if(!isHtmlElement(list_wrapper)) {
            console.warn('must define valid html element or selector');
        }
        hideMarkers(map.markers);
        hideAllInfoWindow(map);

        var points = getVisibleMarkers(map);
        var geolocalisation = getFilterValue("#search-provider");

        // Distance ranking if field search localisation is not empty
        if(geolocalisation !== "") {
            points = orderByDistance(points, map);
        }

        // Apply specific filters based on map type
        switch(mapType) {
            case 'provider':
                var provider_type = map.provider_type;
                points = filterMarkerBy(points, "#provider-type","provider_type", false, provider_type);
                
                switch(provider_type){
                    case 'Rentals':
                        points = filterSystemByStandard(points);
                        points = orderMarkerBy(points, "system_weight", false);
                        break;
                    case 'Integration':
                        points = filterMarkersByMarketSegments(points);
                        break;
                    case 'Distribution':
                        points = filterMarkerBy(points, "#la-creations-distributor","la_creations", true);
                        break;
                }
                
                points = orderMarkerBy(points, "system_integrator_network_agent");
                points = orderMarkerBy(points, "certified_provider");
                break;
                
            case 'training':
                //for debug
                if(mapType === 'training') {
                    map.markers.forEach(function(marker) {
                        if(marker.infos && marker.infos.post_type === 'training_centers') {
                            //console.log('Training Center Marker:', marker.infos);
                        }
                    });
                }
                var selected = getFilterValue("#training-for");
                if(selected !== "all") {
                    points = points.filter(function(marker){
                        return Array.isArray(marker.infos.training_certified_for) && marker.infos.training_certified_for.includes(selected);
                    });
                }
                break;
                
            case 'venue':
                points = filterMarkersByVenueType(points, getCurrentVenueTypeSelection());
                points = filterPremiumVenue(points);
                var concertOnly = jQuery('#concert-venues-only').is(':checked');
                var theatreOnly = jQuery('#theatre-venues-only').is(':checked');
                if (concertOnly || theatreOnly) {
                    points = points.filter(function(marker) {
                        return marker.infos && (
                            (concertOnly && marker.infos.concert_venue === true) ||
                            (theatreOnly && marker.infos.theatre_venue === true)
                        );
                    });
                }
                points = orderVenuesByCertifiedFirst(points);
                break;
        }

        showMarkers(points);

        if (map.clusters !== null && map.clusters !== undefined) {
            map.clusters.clearMarkers();
            map.clusters.addMarkers(points);
        }

        if(map.getZoom() > 3 && (mapType !== 'provider' || map.provider_type !== 'all')) {
            updatePointsList(map, points, list_wrapper);
        } else {
            updatePointsList(map, [], list_wrapper);
        }
    }

    // Wrapper functions to maintain backward compatibility
    function refreshMap(map, list_wrapper) {
        return refreshMapGeneric(map, list_wrapper, 'provider');
    }

    function markerExist(markerSearchName, markers){
        var exist = false;
        for(m of markers){
            if(m.infos.name === markerSearchName)
                exist = true;
        }
        return exist;
    }

    function markerUnique(markers) {
        var filtered = [];
        for (mrk of markers) {
            if (markerExist(mrk.infos.name, filtered) === false) {
                filtered.push(mrk);
            }
        }
        return filtered;
    }
/******************************************************************************/

/***************************** about us map **********************************/
    function initAboutUsNavigation(map) {
        jQuery('.map-navigation .links a.not-anchor').on('click', function (e) {
            e.preventDefault();
            jQuery('.map-navigation .links a.not-anchor').removeClass('selected');
            jQuery(this).addClass('selected');
            showAboutUsMarkers(map);
        });
    }

    function getVisibleSites(map, type) {
        var sites = [];
        for (marker of map.markers) {
            if (marker.type === type) {
                marker.setOptions({visible: true});
                sites.push(marker);
            } else {
                marker.setOptions({visible: false});
            }
        }
        return sites;
    }

    function showAboutUsMarkers(map) {
        let element = jQuery('.map-navigation .links a.not-anchor.selected');
        let type = element.attr('data-value');
        let visibleMarkers = getVisibleSites(map, type);

        if (type === 'headquarter') {
            centerMap(map, visibleMarkers);
            map.panBy(0, -100);
            let newZoom = map.getZoom() - 0.5;
            map.setZoom(newZoom);
        } else {
            centerMap(map, visibleMarkers);
            map.panBy(0, -100);
            let newZoom = map.getZoom() - 1;
            map.setZoom(newZoom);
        }
    }
/****************************************************************************/

/********************** Find a training center ******************************/
function refreshMapTraining(map, list_wrapper) {
    return refreshMapGeneric(map, list_wrapper, 'training');
}

/********************** Find L-ISA Auditorium ******************************/
function refreshMapAuditorium(map, list_wrapper) {
    return refreshMapGeneric(map, list_wrapper, 'auditorium');
}

/************************** Find L-ISA Venue *******************************/
function getCurrentVenueTypeSelection() {
        var selectedOption = document.querySelector('.venue-type .custom-option.selected');
        return selectedOption ? selectedOption.getAttribute('data-value') : 'all';
    }

    function filterMarkersByVenueType(markers, selectedType = 'all') {
        if (!selectedType || selectedType === 'all') {
            return markers;
        }

        return markers.filter(function(marker) {
            if (!marker || !marker.infos || !marker.infos.post_type) {
                return false;
            }

            switch (selectedType) {
                case 'L-ISA Certified Venue':
                    return marker.infos.post_type === 'certified_venues';
                case 'L-ISA Studio':
                    return marker.infos.post_type === 'l-isa-studios';
                case 'L-ISA Venue':
                    return marker.infos.post_type === 'lisa_venues';
                case 'L-ISA Auditorium':
                    return marker.infos.post_type === 'lisa_auditoriums';
                default:
                    return true;
            }
        });
    }

    function filterPremiumVenue(markers) {
    var value = jQuery('#premium-venue-select').val();
    if (value === 'all') return markers;
    return markers.filter(function(marker) {
        if (value === 'premium') return marker.infos.premium === true;
        if (value === 'standard') return marker.infos.premium === false;
        return true;
    });
}

function refreshMapVenue(map, list_wrapper) {
    return refreshMapGeneric(map, list_wrapper, 'venue');
}

window.centerMap = centerMap;
window.initMarker = initMarker;
window.geocodeAddress = geocodeAddress;
window.geocodeFromField = geocodeFromField;
window.searchFieldGeocode = searchFieldGeocode;
window.getVisibleMarkers = getVisibleMarkers;
window.buildTagLine = buildTagLine;
window.appendPointToDom = appendPointToDom;
window.updatePointsList = updatePointsList;
window.getHtmlProviderInfo = getHtmlProviderInfo;
window.hideMarkers = hideMarkers;
window.showMarkers = showMarkers;
window.hideAllInfoWindow = hideAllInfoWindow;
window.getDistanceWith = getDistanceWith;
window.filterMarkerBy = filterMarkerBy;
window.filterMarkersByMarketSegments = filterMarkersByMarketSegments;
window.filterSystemByStandard = filterSystemByStandard;
window.orderMarkerBy = orderMarkerBy;
window.orderByDistance = orderByDistance;
window.orderVenuesByCertifiedFirst = orderVenuesByCertifiedFirst;
window.getFilterValue = getFilterValue;
window.isHtmlElement = isHtmlElement;
window.resetDisplayInputSection = resetDisplayInputSection;
window.uddateListResults = uddateListResults;
window.initMapForm = initMapForm;
window.refreshMap = refreshMap;
window.markerExist = markerExist;
window.markerUnique = markerUnique;
window.initAboutUsNavigation = initAboutUsNavigation;
window.getVisibleSites = getVisibleSites;
window.showAboutUsMarkers = showAboutUsMarkers;
window.refreshMapTraining = refreshMapTraining;
window.refreshMapAuditorium = refreshMapAuditorium;
window.filterPremiumVenue = filterPremiumVenue;
window.refreshMapVenue = refreshMapVenue;
